import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

export default function TermsConditions() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen pt-20 lg:pt-24 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <button
          onClick={() => navigate("/support")}
          className="flex items-center gap-2 text-slate-600 hover:text-slate-900 mb-8 transition-colors"
        >
          <ArrowLeft size={20} weight="bold" />
          <span className="font-medium">Back to Support</span>
        </button>

        <div className="text-center mb-10">
          <h1 className="text-3xl sm:text-4xl font-black text-[#0F172A] mb-4">Terms & Conditions</h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            The terms that govern use of the Loado platform for logistics booking and material marketplace services.
          </p>
        </div>

        <div className="space-y-8 text-slate-600">
          <p>
            Welcome to Loado. By using our mobile application and website, you agree to comply with and be bound by the following terms. Please read them carefully.
          </p>

          <section className="space-y-4">
            <h2 className="font-bold text-[#0F172A] text-xl">1. Nature of Platform</h2>
            <p>Loado is a digital aggregator platform that facilitates two primary services:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Logistics Booking:</strong> Connecting users with independent Delivery Partners (Bikes to Heavy Trucks).</li>
              <li><strong>Material Marketplace:</strong> Connecting Builders/Contractors with Construction Material Sellers.</li>
            </ul>
            <div className="mt-3 p-3 bg-slate-50 border-l-4 border-slate-400 text-sm text-slate-700">
              Loado is a <strong>facilitator</strong> and is not the manufacturer of materials or the direct employer of delivery partners.
            </div>
          </section>

          <section className="space-y-4">
            <h2 className="font-bold text-[#0F172A] text-xl">2. User Accounts & Verification</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Eligibility:</strong> You must be 18 years or older to use Loado.</li>
              <li><strong>Accuracy:</strong> Users (Sellers, Partners, and Customers) must provide accurate data, including Aadhar, PAN, GST, DL, and RC as requested.</li>
              <li><strong>Verification:</strong> Loado reserves the right to suspend accounts that fail background checks or provide fraudulent documentation.</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="font-bold text-[#0F172A] text-xl">3. Material Purchase & Quality Control</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Pricing:</strong> Material prices (Cement, Steel, Sand, etc.) are updated in real-time based on market fluctuations. The price at the time of "Order Confirmation" is final.</li>
              <li><strong>Inspection:</strong> The Customer must inspect all materials before unloading.</li>
              <li><strong>Acceptance:</strong> Once material is unloaded from the vehicle, it is deemed "Accepted" by the customer. No returns, replacements, or refunds will be entertained post-unloading.</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="font-bold text-[#0F172A] text-xl">4. Logistics & Fleet Services</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Vehicle Suitability:</strong> Customers are responsible for booking the correct vehicle type for their load. If a vehicle is overloaded beyond its legal RC capacity, the Partner may refuse the trip, and a cancellation fee will apply.</li>
              <li><strong>Pay After Delivery:</strong> Fleet/Logistics charges are payable immediately upon delivery. Failure to pay the Delivery Partner is a breach of contract and will lead to legal action and account termination.</li>
              <li><strong>Waiting Charges:</strong> A free waiting window available for each type of vehicle is provided for loading/unloading. Beyond this, a "Waiting Fee" will be added to the final bill.</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="font-bold text-[#0F172A] text-xl">5. Cancellation & Refund Policy</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Platform Fee:</strong> All material cancellations incur a 2% non-refundable processing fee.</li>
              <li><strong>Logistics Liability:</strong> If a cancellation occurs after a Delivery Partner is allocated and "In-Transit," the customer is liable to pay the Full Fleet Charge.</li>
              <li><strong>Seller Liability:</strong> If a material order is rejected before unloading due to verified quality issues (with photo proof), the Seller is liable for the fleet charges and platform fees.</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="font-bold text-[#0F172A] text-xl">6. Limitation of Liability</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Loado is not liable for structural failures, project delays, or indirect damages resulting from material quality or delivery timing.</li>
              <li>Our maximum liability is limited to the Platform Fee collected for the specific transaction in dispute.</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="font-bold text-[#0F172A] text-xl">7. Restricted Activities</h2>
            <p>Users shall not:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Transport illegal, hazardous, or explosive materials.</li>
              <li>Negotiate "Offline" payments to bypass Loado platform fees.</li>
              <li>Provide false site coordinates or misleading material descriptions.</li>
            </ul>
          </section>

          <section className="space-y-4 p-4 bg-slate-100 border border-slate-300 rounded-lg">
            <h2 className="font-bold text-[#0F172A] text-xl">8. Governing Law</h2>
            <p>These terms are governed by the laws of <strong>India</strong>. Any disputes shall be subject to the exclusive <strong>Chennai jurisdiction</strong> of the courts where Loado is headquartered.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
